import { Box, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import PlayIcon from "../../images/play_icon_purple.svg";

const Section4 = ({ primary }) => {
  const theme = useTheme();
  const { section_header, section_cta_text, section_cta_link } = primary;

  return (
    <Stack
      sx={{
        backgroundColor: theme.palette.secondary.light,
        pt: "80px",
        pb: "140px",
        px: "20px",
        alignItems: "center",
      }}
      gap={3}
    >
      <Typography
        variant="h1"
        sx={{
          color: theme.palette.primary.dark,
          fontSize: "36px",
          fontWeight: "900",
          textAlign: "center",
        }}
      >
        {section_header.text}
      </Typography>

      <Box
        sx={{
          width: "100%",
          maxWidth: "250px",
          borderRadius: "35px",
          padding: "7px 37px 7px 9px",
          height: "70px",
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          border: "solid 2px",
          borderColor: theme.palette.primary.main,
          background: "transparent",
          textDecoration: "none",
          "&:hover": {
            cursor: "pointer",
            backgroundColor: theme.palette.primary.main,
            "& p": {
              color: "#ffffff",
            },
          },
        }}
        component="a"
        href={section_cta_link.url}
        target={section_cta_link.target}
      >
        <Box
          component="img"
          src={PlayIcon}
          sx={{
            marginRight: "15px",
          }}
        />

        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontWeight: "bold",
            fontSize: "18px",
            textTransform: "uppercase",
          }}
        >
          {section_cta_text.text}
        </Typography>
      </Box>
    </Stack>
  );
};

export default Section4;
